
export const ALL_SALES_PERSON_INVENTORY_REQUEST = "ALL_SALES_PERSON_INVENTORY_REQUEST";
export const ALL_SALES_PERSON_INVENTORY_SUCCESS = "ALL_SALES_PERSON_INVENTORY_SUCCESS";
export const ALL_SALES_PERSON_INVENTORY_FAIL = "ALL_SALES_PERSON_INVENTORY_FAIL";

export const ALL_SALES_PERSON_ORDER_REQUEST = "ALL_SALES_PERSON_ORDER_REQUEST";
export const ALL_SALES_PERSON_ORDER_SUCCESS = "ALL_SALES_PERSON_ORDER_SUCCESS";
export const ALL_SALES_PERSON_ORDER_FAIL = "ALL_SALES_PERSON_ORDER_FAIL";
